<template>
  <div id="app">
    <!-- Using McServerList component to create Minecraft server interface -->
    <McServerList />
  </div>
</template>

<script>
import McServerList from './components/McServerList.vue'

export default {
  name: 'app',
  components: {
    McServerList
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#app {
  width: 100%;
  height: 100vh;
}
</style>
